const publisherAdapter = p => ({
  id: p.id,
  ...p.attributes,
  relationships: {
    ...p.relationships,
  },
});

export default publisherAdapter;
